module.exports = __webpack_public_path__ + "static/media/5.a87d6a2e.jpeg";